<template>
    <div>
        <div class="flex-container">
            <div>
                <button @click="headerButtonClicked"><img src="https://xperienceeducation-assets.s3.amazonaws.com/shared/Logo.svg" alt="XEDU Logo"></button>
            </div>
        </div>
    </div>
</template>

<script>

import { useRouter  } from 'vue-router';

export default {
    "name": "header-comp",
    setup() {

        const router = useRouter();

        function headerButtonClicked(){
            router.push('/');
        }
    
        return{
            headerButtonClicked
        }
    },
}
</script>

<style lang="scss" scoped>
@import '@/styles/shared.scss';

.flex-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 1%;
    padding-top: 1%;

}

img{
    width: 150px;

      @media(min-width: $bp-tablet-portrait){
        width: 200px; 
    }
}

button{
    cursor: pointer;
    background: none;
    border: none;
}

</style>